import { BadgeUserCertified, BadgeUserPendingCertification } from '@/components/custom';
import { TableCell } from '@/components/ui';
import { IHasUser } from '.';

export const DataTableBodyCellUsername = ({ user }: IHasUser) => (
  <TableCell className='py-1 pe-0 w-0 text-sm font-semibold text-nowrap'>
    <div className='flex items-center space-x-1'>
      <span>
        {user.username}
      </span>
      <BadgeUserCertified
        size={16}
        user={user} />
      <BadgeUserPendingCertification
        mode='loader'
        size={16}
        user={user} />
    </div>
  </TableCell>
);

export default DataTableBodyCellUsername;
